<template>
  <div class="expand-item-container">
    <div class="expand-item">
      商品名称：{{row.goodsName}}
    </div>
    <div class="expand-item">
      生产厂家：{{row.manufacturer}}
    </div>
    <div class="expand-item">
      剂型：{{row.dosageForm}}
    </div>
    <div class="expand-item">
      单位：{{row.drugMiniPackageUnit}}
    </div>
    <div class="expand-item">
      供应商：{{row.supplierName}}
    </div>
    <div class="expand-item">
      批次：{{row.goodsBatchSeq}}
    </div>
  </div>
</template>
<script>

export default {
  name: 'CuringResultExpand',
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
  },
};
</script>
